import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { CheckIcon, MinusIcon } from "@radix-ui/react-icons"

import { cn } from "../../lib/utils"

const Checkbox = React.forwardRef(({ className, checked, ...props }, ref) => {
  const internalRef = React.useRef(null);
  const checkboxRef = ref || internalRef;
  const isIndeterminate = checked === 'indeterminate';
  const isChecked = checked === true;
  
  // Set indeterminate state and background color on the underlying button element
  React.useEffect(() => {
    if (checkboxRef?.current) {
      const button = checkboxRef.current;
      if (isIndeterminate) {
        button.setAttribute('data-state', 'indeterminate');
        button.style.backgroundColor = '#020817';
        button.style.color = 'white';
        // Also try to set on any nested input if it exists
        const input = button.querySelector('input[type="checkbox"]');
        if (input) {
          input.indeterminate = true;
        }
      } else if (isChecked) {
        button.setAttribute('data-state', 'checked');
        button.style.backgroundColor = '#020817';
        button.style.color = 'white';
        const input = button.querySelector('input[type="checkbox"]');
        if (input) {
          input.indeterminate = false;
        }
      } else {
        button.removeAttribute('data-state');
        button.style.backgroundColor = '';
        button.style.color = '';
        const input = button.querySelector('input[type="checkbox"]');
        if (input) {
          input.indeterminate = false;
        }
      }
    }
  }, [isIndeterminate, isChecked, checkboxRef]);
  
  return (
    <CheckboxPrimitive.Root
      ref={checkboxRef}
      className={cn(
        "peer h-5 w-5 shrink-0 rounded-sm border shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        isChecked && "bg-[#020817] text-white",
        isIndeterminate && "bg-[#020817] text-white [&>div]:flex",
        className
      )}
      checked={isIndeterminate ? false : checked}
      {...props}
    >
      {isIndeterminate ? (
        <div className="flex items-center justify-center text-current w-full h-full">
          <MinusIcon className="h-4 w-4" />
        </div>
      ) : (
        <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current")}>
          <CheckIcon className="h-4 w-4" />
        </CheckboxPrimitive.Indicator>
      )}
    </CheckboxPrimitive.Root>
  );
})
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox } 